<template>
    <div class="radio-item-select">
        <radio-item-select-option
            class="radio-item-select__collapsed-state"
            :checked="true"
            :title="options.find(option => option.key === selected).value"
            :icon="isCollapsed ? 'chevron-down' : 'chevron-up'"
            @click="$emit('toggleCollapse')" />
        <div class="radio-item-select__frame">
            <div
                v-if="!isCollapsed"
                class="radio-item-select__list-wrapper">
                <div class="radio-item-select__list-text">
                    {{ listText }}
                </div>
                <div class="radio-item-select__list-items">
                    <radio-item-select-option
                        v-for="option in options"
                        :key="option.key.name"
                        :checked="option.key === selected"
                        :title="option.value"
                        @click="$emit('onSelect', option.key)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RadioItemSelectOption from '@/components/common/RadioItemSelectOption';

export default {
    name: 'RadioItemSelect',
    components: {
        RadioItemSelectOption,
    },
    props: {
        isCollapsed: {
            type: Boolean,
            required: true,
        },
        options: {
            type: Array,
            required: true,
        },
        selected: {
            type: Object,
            required: true,
        },
        listText: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss">
  .radio-item-select__collapsed-state {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  }
  .radio-item-select__frame {
    position: relative;

    .radio-item-select__list-wrapper {
        background: $mb-grey-12;
        width: 84%; // Yes! 84% - approved by the designer.
        position: absolute;
        top: 0;
        right: 0;
        margin-top: 5px;
        padding-left: 5px;
        padding-bottom: 20px;
        padding-top: 20px;
        z-index: 2;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    }
  }

  .radio-item-select__list-text {
      @include bold();
      padding-left: 10px;
      padding-bottom: 20px;
      line-height: 18px;
  }
</style>
